import { theme } from "../../";
import { WEBP_FILE_EXTENSION, LQIP_WIDTH } from "./types";

export function parsePath(path = ""): {
  dirName: string;
  baseName: string;
  fileName: string;
  extension: string;
} {
  const slashParts = path.split("/");
  const dirName =
    slashParts.length < 2 ? "" : slashParts.slice(0, -1).join("/");
  const baseName = slashParts[slashParts.length - 1];
  const dotParts = baseName.split(".");

  const extension = dotParts.length < 2 ? "" : dotParts[dotParts.length - 1];
  const fileName =
    dotParts.length < 2 ? baseName : dotParts.slice(0, -1).join(".");

  return { dirName, baseName, fileName, extension };
}

export const buildImageUrl = (
  dirName: string,
  fileName: string,
  extension: string,
  w: number,
  h: number | null = null,
  retina = false
) => {
  let fname = fileName;
  if (w || h) fname += "_";
  if (w) fname += "w" + w;
  if (h) fname += "h" + h;
  if (retina) fname += "@2x";

  return `${dirName}/${fname}.${extension}`;
};

export const generateSizesAttrValue = (sizeMap) =>
  sizeMap &&
  ["xl", "lg", "md", "sm"]
    .filter((size) => Object.prototype.hasOwnProperty.call(sizeMap, size))
    .map(
      (size) =>
        `(min-width: ${theme.breakpoints[size]}) ${sizeMap[size]}${
          typeof sizeMap[size] === "number" ? "px" : ""
        }`
    )
    .join(", ")
    .concat(
      `, ${sizeMap.default || "200"}${
        typeof sizeMap.default === "number" ? "px" : ""
      }`
    );

export const getSources = (src = "", widths: number[], ratio?: number) => {
  const { dirName, fileName, extension } = parsePath(src);

  /** source set for webp image sources */
  const webpSrcSet = widths
    .map((width) => {
      const height = ratio ? Math.round(width * (ratio / 100)) : undefined;
      return `${buildImageUrl(
        dirName,
        fileName,
        WEBP_FILE_EXTENSION,
        width,
        height
      )} ${width}w${height ? ` ${height}h` : ""}`;
    })
    .join(", ");

  /** source set for other image sources e.g. jpg, gif */
  const imageSrcSet = widths
    .map(
      (size) => `${buildImageUrl(dirName, fileName, extension, size)} ${size}w`
    )
    .join(", ");

  /** source LQIP (Low Quality Image Placeholder) */
  const lqipSrc = buildImageUrl(dirName, fileName, extension, LQIP_WIDTH);

  /** get an average resolution image source for IE */
  const ieSrc = buildImageUrl(
    dirName,
    fileName,
    extension,
    widths[Math.floor(widths.length / 2)]
  );

  return { webpSrcSet, imageSrcSet, lqipSrc, ieSrc, extension };
};
